import { Fragment, memo } from 'react';
import { ICON_COLOR } from '@zep-us/zus/tokens';
import { useTranslation } from 'next-i18next';
import { SquareStackIcon, SwitchIcon, TrashIcon } from '@/icons';
import { AiGenerateSimilarQuizModal } from '../AiGenerateSimilarQuizModal';
import { useEditMode } from '../focus/useIsEditMode';
import { useQuizList } from '../useQuizList';
import { useMultipleOptions } from './Multiple/useMultipleOptions';
import { EditableHint } from './EditableHint';
import { EditTools } from './EditTools';
import { EditableMultiple } from './Multiple';
import { useQuizControl } from './QuizControlProvider';
export const MultipleBody = memo(({
  leftSlot
}: {
  leftSlot: React.ReactNode;
}) => {
  const {
    control,
    index
  } = useQuizControl();
  const {
    handleCopy,
    handleDelete
  } = useQuizList();
  const {
    t
  } = useTranslation(['common', 'build']);
  const {
    options,
    handleRemove,
    handleMove,
    handleInsert,
    handleAdd,
    handleShuffle
  } = useMultipleOptions({
    control,
    index
  });
  const {
    isEditMode
  } = useEditMode();
  return <Fragment>
        <div className="flex flex-row justify-between" onClick={e => e.stopPropagation()}>
          {leftSlot}
          <div className="flex flex-row items-center gap-xs">
            {!isEditMode && <>
                <AiGenerateSimilarQuizModal />
                <EditTools.Divider />
              </>}

            {isEditMode && <>
                <EditTools.ChoiceRandomShuffleButton onClick={handleShuffle} />
                <EditTools.Divider className="hidden mobile-lg:flex" />
              </>}
            <EditTools.QuizDuplicateButton />
            <EditTools.QuizDeleteButton />
            <EditTools.EditToolsDrawer tools={[{
          icon: <SquareStackIcon size="md" fill={ICON_COLOR.default} />,
          label: t('global.duplicate.button'),
          onClick: () => handleCopy(index)
        }, {
          icon: <TrashIcon size="md" fill={ICON_COLOR.default} />,
          label: t('global.delete'),
          onClick: () => {
            void handleDelete(index);
          }
        }, {
          icon: <SwitchIcon size="md" fill={ICON_COLOR.default} />,
          label: t('build:mixChoices'),
          onClick: handleShuffle
        }]} />
          </div>
        </div>

        <div className="flex flex-col justify-between gap-xs" onClick={e => e.stopPropagation()}>
          <EditableMultiple options={options} handleRemove={handleRemove} handleMove={handleMove} handleInsert={handleInsert} handleAdd={handleAdd} />
          <EditableHint />
        </div>
      </Fragment>;
});